import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-checked-60px" }, null, -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("strong", {
    class: "oto-academy__modal__title",
    "data-cy": "oto-academy-modal-created-text"
}, "Parabéns! Sua inscrição foi confirmada.", -1);
const _hoisted_3 = { class: "oto-academy__modal__text" };
const _hoisted_4 = { "data-cy": "oto-academy-modal-create-email" };
const _hoisted_5 = { class: "dialog" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalCreateUser',
    props: {
        isVisible: { type: Boolean },
        email: {},
        loading: { type: Boolean }
    },
    emits: ['hide'],
    setup(__props, { emit }) {
        const props = __props;
        const hide = () => {
            emit('hide', 'createUser');
        };
        return (_ctx, _cache) => {
            const _component_loader_spinner = _resolveComponent("loader-spinner");
            const _component_btn = _resolveComponent("btn");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: props.isVisible,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((props.isVisible) = $event)),
                "show-close": false,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                width: "400",
                center: "",
                class: "oto-academy__modal"
            }, {
                default: _withCtx(() => [
                    (props.loading)
                        ? (_openBlock(), _createBlock(_component_loader_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_1,
                            _hoisted_2,
                            _createElementVNode("p", _hoisted_3, [
                                _createTextVNode(" Em alguns minutos, você receberá um e-mail em "),
                                _createElementVNode("b", _hoisted_4, _toDisplayString(props.email), 1),
                                _createTextVNode(" com as instruções de acesso. O e-mail conterá seu login, senha e o link de acesso à plataforma. ")
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_btn, {
                                    class: "btn",
                                    onClick: hide
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("Entendi")
                                    ]),
                                    _: 1
                                })
                            ])
                        ], 64))
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
